<div class="container">
    <div class="row">
        <div class="col p-0">
            <app-reports-filter
                [selectedReport]="reportModel"
                [generateDisabled]="generateDisabled"
                [showClassFilter]="true"
                [instructors]="instructors"
                [classes]="displayedClasses"
                (filtersSelected)="filterClass($event)"
                (doFilter)="showReport($event)"
                (generateReport)="generateReportFile($event)">
            </app-reports-filter>
        </div>
    </div>
    <div class="row mt-3" *ngIf="reportData.length > 0">
        <div class="col p-0">
            <div class="row attendance-report-header align-items-center">
                <div class="col-2 p-0">
                    <div class="row align-items-center">
                        <div class="col-6">{{ 'AttendanceReport.DateHeader' | translate }}</div>
                        <div class="col-3 text-center">{{ 'AttendanceReport.TotalHoursHeader' | translate }}</div>
                        <div class="col-3 text-center">{{ 'AttendanceReport.TotalCostHeader' | translate }}</div>
                    </div>
                </div>
                <div class="col-10 p-0">
                    <div class="row align-items-center">
                        <div class="col-2">{{ 'AttendanceReport.ClubNameHeader' | translate }}</div>
                        <div class="col">{{ 'AttendanceReport.InstructorHeader' | translate }}</div>
                        <div class="col">{{ 'AttendanceReport.CategoryHeader' | translate }}</div>

                        <div class="col">{{ 'AttendanceReport.ClassNameHeader' | translate }}</div>
                        <div class="col">{{ 'AttendanceReport.TimeHeader' | translate }}</div>
                        <div class="col-1 text-center">
                            {{ 'AttendanceReport.ActualAndBillableTimeHeader' | translate }}
                        </div>
                        <div class="col-1 text-center">{{ 'AttendanceReport.CostHeader' | translate }}</div>
                        <div class="col-1 text-center">{{ 'AttendanceReport.AttendanceHeader' | translate }}</div>

                        <div class="col-1 text-center">{{ 'AttendanceReport.CostPerHeadHeader' | translate }}</div>

                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <app-attendance-report-item *ngFor="let item of reportData" [summaryItem]="item">
                    </app-attendance-report-item>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-2" *ngIf="reportData.length === 0">
        <div class="col text-center">
            <div><span class="ic-binoculars"></span></div>
            <div>{{ 'AttendanceReport.NoRecords' | translate }}</div>
        </div>
    </div>
</div>
